import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
  TextField,
  FormControl,
  Radio,
  OutlinedInput,
  Icon,
  Chip,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
} from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'

import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';

import dayjs from 'dayjs'
import * as Util from "../../../../services/global.service";

import { getGoalType, getDropdownMetric, getDropdownUnit, getGroupCategory, getAlignmentList, postCreateMyGoal, getScaleLevel, getGoalForEdit, putEditMyGoal, getCustomForm } from "../../../../actions/corporateGoal";

import SimpleDialog from "../../../../components/SimpleDialog";
import WarningDialog from "../../../../components/WarningConfirm";
import MoreDetailCustom from "../../../../components/kpi/MoreDetailCustom";

import { ReactComponent as BackIcon } from "../../../../icons/arrow-left.svg";
import { ReactComponent as InNoneAlign } from "../../../../icons/innone-align.svg";
import { ReactComponent as NoneAlign } from "../../../../icons/none-align.svg";
import { ReactComponent as LinkActive } from "../../../../icons/link-goal-active.svg";
import { ReactComponent as LinkInactive } from "../../../../icons/link-goal-inactive.svg";

// import axios from "axios";
const CreateFormCorporateGoal = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _ = require("lodash");
  const navigate = useNavigate();
  let { id } = useParams();
  const { state } = useLocation();
  const goalDetailRef = useRef(null)
  const goalMemberRef = useRef(null)
  const goalWeightRef = useRef(null)
  const moreDetailRef = useRef(null)
  const goalTypeRef = useRef(null)
  const goalScaleRef = useRef(null)
  const [isSubmitClicked, setIsSubmitClicked] = React.useState(false)


  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
    memberSearch: {
      maxHeight: '300px',
      padding: '37px',
      width: "99%",
      minHeight: "50px",
      background: "#FFF",
      zIndex: "10",
      webkitBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      mozBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      boxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      overflow: 'hidden',
    },
    alignmentSearch: {
      maxHeight: '300px',
      padding: '37px',
      width: "99%",
      minHeight: "50px",
      background: "#FFF",
      zIndex: "10",
      webkitBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      mozBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      boxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      overflow: 'hidden',
      marginLeft: '15px',
    },
    notchedOutline: {
      borderColor: "#5DA196 !important"
    }
  };

  const useStyles = makeStyles({
    closeSvg: {
      "& > path": {
        fill: "#5DA196"
      },
      '& g > path': {
        fill: '#5DA196'
      },
    },
    customTextField: {
      "& input::placeholder": {
        fontSize: "16px",
        color: '#A3A3A3',
      }
    },
    disabled: {
      background: "#F3F3F3!important"
    },
    "error": {
      color: " #CC6058 !important",
    },

  })

  const classes = useStyles();

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));

  // Function Start
  // Common Start
  const goto = (path, data) => {
    if (data) {
      navigate("/admin" + path, { replace: false, state: data });
    } else {
      navigate("/admin" + path, { state: data });
    }
  }

  const isEmpty = (data) => {
    if (data == null || data == "" || data.length == 0 || !data) {
      return true
    } else
      return false
  }

  const confirmPage = () => {
    let isValid = true
    let goalMetricSerial = respOption.find((item) => { if (item.code === goalMetric.toLowerCase()) { return item.serial } })?.serial
    if (!goalMetricSerial) goalMetricSerial = respOption.find((item) => { if (item.description === goalMetric) { return item.serial } })?.serial

    //console.log('goalMetricSerial', goalMetric, goalMetricSerial, respOption); return;
    // let sendEvaluatorSerial = "";
    // if(evaluator) {
    //   sendEvaluatorSerial = selectOption?.evaluator.find((item) => {if((`${item.firstName} ${item.lastName}`) === evaluator) return item}).serial
    // }
    const scaleForConvert = [...scaleLevel]
    const scaleLevelFilter = scaleForConvert.filter((item) => item.max_value !== null)
    const scaleConvertDate = scaleLevelFilter.map((item) => {
      if (goalMetric.toLowerCase() === 'date') {
        const scaleDate = {
          value_min: dayjs(item.min_value).format('DD/MM/YYYY'),
          value_max: dayjs(item.max_value).format('DD/MM/YYYY'),
          serial: item.serial
        }
        return scaleDate;
      } else {
        const scaleValue = {
          value_min: item.min_value,
          value_max: item.max_value,
          serial: item.serial
        }
        return scaleValue
      }
    })
    let goalMetricUnit = "";
    let goalTypeSerial = "";
    if (goalType === 3 || goalType === 2 || goalType === 1) {
      const goalTypeList = { ...selectOption };
      const goalTypeData = goalTypeList.goalType.filter((item) => item.code === (goalType === 3 ? 'personal' : goalType === 2 ? 'team' : 'corporate'))[0]
      goalTypeSerial = goalTypeData.serial
    } else {
      goalTypeSerial = goalType
    }

    if (goalCategory === "" || !goalCategory) {
      isValid = false
    }
    var data = {
      goal_detail: {
        goal_name: goalName,
        goal_details: goalDetail,
        measurement: measurement,
        more_detail: moreDetail.length > 0 ? moreDetail : [],
        start_date: dayjs(startDate).format('YYYY-MM-DD'),
        end_date: dayjs(endDate).format('YYYY-MM-DD'),
        goal_metric: goalMetricSerial,
        target_condition: condition?.toLowerCase() || "",
        unit: (condition && !others) ? unit : "",
        specify_unit: others || "",
        target_value: targetValue,
      },
      goal_category: {
        kpi_goal_template_category_id: goalCategory,
        evaluation_weight: weight.toString(),
      },
      more_detail: moreDetail.length > 0 ? moreDetail : [],
      measurement: measurement,
      scale_level: scaleLevelCheckbox ? scaleConvertDate : [],
      goal_type: goalTypeSerial,
      suggestion_type: "",
      goal_template_id: goalTemplateSerial ?? null,
      goal_master_id: state?.librarySerial ?? "",
      kpi_form_evaluate_id: evaluatorSerial,
      evaluator_permission: {
        evaluator: evaluator ?? "",
        permission: permission?.toLowerCase() ?? "public",
      },
      goal_member: {},
      linking_goal: {
        linking_goal_type: type === 'Associated Goal'
          ? 'linking_associate'
          : type === 'Parent Goal'
            ? 'linking_parent' : undefined,
        linked_goal: value?.length > 0 ? value : undefined
      },
      cascade_goal: {
        assigned_type: alignmentList.length > 0 ? "cascading" : undefined,
        assigned_members: alignmentList.length > 0 ? alignmentList.map((item) => item.serial) : undefined
      },
      kpi_form_id: "",
      cycle_id: cycleSerial,
      is_linking_goal: goalAlignment === 1 ? true : false
    }
    if (isValid) {
      if (id === 'edit') {
        Object.assign(data, {
          update_data: {
            goal_serial: kpiGoalId,
            goal_form_serial: state.goalSerial
          }
        })
        dispatch(putEditMyGoal(state.goalSerial, data))
          .then(resp => {
            if (resp?.success) {
              // openConfirmEditOpen(false);
              openSuccessEditOpen(true);
            }
          })
      } else {
        dispatch(postCreateMyGoal(data))
          .then(resp => {
            if (resp?.data?.success) {
              goto('/manage-corporate-goal/create-corporate-goal-success', { validCreate: true })
            }
          })
      }
    }
  }

  const chooseCategory = (serial) => {
    setCategory(serial)
    setCategoryWeight(100)
    var alignmentLists = [...alignmentList];
    if (alignmentLists.length > 0) {
      alignmentLists = alignmentLists.map((item) => {
        if (item?.empCategories?.some((data) => data.serial === serial)) {
          item.selectGoalCategory = serial
        }
        return item;
      })
      setAlignmentList(alignmentLists)
    }
  }

  const setPreSelectCategory = (category) => {
    let selectedOptionData = [...goalCategoryOptions].find(item => item.serial === category.serial)
    if (selectedOptionData) {
      chooseCategory(selectedOptionData.serial)
    }
  }

  const handleSuccessEdit = (val) => {
    goto('/manage-corporate-goal');
  };
  // Common End

  // Varify & Set Data Start
  const numberIsEmpty = (scaleLevelList) => {
    var empty = false;
    scaleLevelList.map((scaleLevel, idx) => {
      if (scaleLevel.min_value == null || scaleLevel.max_value == null || !scaleLevel.min_value || !scaleLevel.max_value) {
        empty = true;
      }
    })
    return empty;
  }
  const numberNotOverlap = (scaleLevelList) => {
    var overlap = false;
    var orderScaleLevel = 'asc';
    scaleLevelList.map((scaleLevel, idx) => {
      if (idx == 0) {
        if (parseFloat(scaleLevelList[idx + 1]?.min_value) - parseFloat(scaleLevelList[idx]?.max_value) > 0) {
          orderScaleLevel = 'asc';
          setOrderScale('asc')
        } else {
          orderScaleLevel = 'desc';
          setOrderScale('desc')
        }
      } else {
        if (parseFloat(scaleLevel.max_value) - parseFloat(scaleLevel.min_value) < 0) {
          overlap = true;
        }
        if (orderScaleLevel == 'asc') {
          if (idx + 1 !== scaleLevelList.length) {
            if (parseFloat(scaleLevelList[idx + 1]?.min_value) - parseFloat(scaleLevelList[idx]?.max_value) <= 0) {
              overlap = true;
            }
            if (parseFloat(scaleLevelList[idx + 1]?.max_value) - parseFloat(scaleLevelList[idx]?.min_value) <= 0) {
              overlap = true;
            }
          }
        } else {
          if (idx + 1 !== scaleLevelList.length) {
            if (parseFloat(scaleLevelList[idx + 1]?.min_value) - parseFloat(scaleLevelList[idx]?.max_value) > 0) {
              overlap = true;
            }
            if (parseFloat(scaleLevelList[idx + 1]?.max_value) - parseFloat(scaleLevelList[idx]?.min_value) > 0) {
              overlap = true;
            }
          }
        }
      }
    })
    return overlap;
  }

  const dateNotOverlap = (scaleLevelList) => {
    var overlap = false;
    scaleLevelList.map((scaleLevel, idx) => {
      if (dayjs(scaleLevel.min_value).diff(dayjs(scaleLevel.max_value), 'dates') > 0) {
        overlap = true;
      }
      if (idx < scaleLevelList.length && idx > 0) {
        if (dayjs(scaleLevel.max_value).diff(dayjs(scaleLevelList[idx - 1].min_value), 'dates') >= 0) {
          overlap = true;
        }
      }
    })
    return overlap;
  }

  const checkField = () => {
    setIsSubmitClicked(true)
    var data = {}
    if (isEmpty(goalType) && id == "guide") {
      data = Object.assign(data, { goalType: true })
    }
    if (isEmpty(goalName)) {
      data = Object.assign(data, { name: true })
    }
    if (isEmpty(goalDetail)) {
      data = Object.assign(data, { detail: true })
    }
    if (isEmpty(measurement)) {
      data = Object.assign(data, { measurement: true })
    }
    if (isEmpty(startDate)) {
      data = Object.assign(data, { startDate: true })
    }
    if (isEmpty(endDate)) {
      data = Object.assign(data, { endDate: true })
    }
    if (isEmpty(goalMetric)) {
      data = Object.assign(data, { goalMetric: true })
    }
    if (isEmpty(goalCategory)) {
      data = Object.assign(data, { goalCategory: true })
    }

    // New Data
    if (moreDetail.length > 0) {
      let moreData = [];
      moreDetail.map((item) => {
        let empty = false;
        if (isEmpty(item.value) && item.is_required) {
          empty = true;
          moreData.push(empty)
        }
      })
      if (moreData.length > 0) {
        data = Object.assign(data, { moreDetail: moreData })
      }
    }

    if (goalMetric == 'Value') {
      if (isEmpty(condition)) {
        data = Object.assign(data, { condition: true })
      }
      if (isEmpty(unit)) {
        data = Object.assign(data, { unit: true })
      }
      if (isEmpty(targetValue)) {
        data = Object.assign(data, { targetValue: true })
      } else {
        const unitOption = selectOption?.unitOption?.filter((item) => { if (item.serial === unit) return item })[0]
        const min = unitOption?.options?.min_value || 0;
        if (targetValue < min) {
          data = Object.assign(data, { targetValue: true })
        }
      }
    }

    if (unit === "custom") {
      // console.log(unit, others)
      if (isEmpty(others)) {
        data = Object.assign(data, { others: true })
      }
    }
    if (isEmpty(weight) || (categoryWeight - weight < 0)) {
      data = Object.assign(data, { weight: true })
    }
    if (scaleLevelCheckbox) {
      if (goalMetric == 'Date') {
        if (numberIsEmpty(scaleLevel)) {
          data = Object.assign(data, { scaleLevelEmpty: true })
        } else if (dateNotOverlap(scaleLevel)) {
          data = Object.assign(data, { scaleLevel: true })
        }
      } else if (goalMetric == 'Value') {
        if (numberIsEmpty(scaleLevel)) {
          data = Object.assign(data, { scaleLevelEmpty: true })
        } else if (numberNotOverlap(scaleLevel)) {
          data = Object.assign(data, { scaleLevel: true })
        }
      }
    }
    if (goalAlignment === 1) {
      if (isEmpty(type) || isEmpty(value)) {
        data = Object.assign(data, { alignment: true })
      }
    } else if (goalAlignment === 2) {
      if (isEmpty(alignmentList)) {
        data = Object.assign(data, { alignment: true })
      }
    }

    if (Object.keys(data).length != 0 && data.goalType) {
      goalTypeRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0
      && (data.name || data.detail || data.measurement || data.startDate || data.endDate || data.goalMetric || data.condition || data.unit || data.targetValue)) {
      goalDetailRef.current.scrollIntoView({ behavior: 'smooth' })
    }
    // New Data
    else if (Object.keys(data).length != 0
      && (data?.moreDetail?.some((data) => data))) {
      moreDetailRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0 && (data.scaleLevel || data.scaleLevelEmpty)) {
      goalScaleRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0 && data.weight) {
      goalWeightRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    if (Object.keys(data).length == 0) {
      // if(id === 'edit') {
      //   openConfirmEditOpen(true);
      // } else {
      confirmPage()
      // }
    }

    setVerifyField(data)
  }

  const handleChange = (value, type) => {
    var stateOption = { ...selectOption };
    if (type == 'evaluator') {
      setEvaluator(value)
    } else if (type == 'metric') {
      setGoalMetric(value)
      if (value == 'Value') {
        setTargetValue("")
        setScaleCondition([
          { min_value: '1', max_value: '20' },
          { min_value: '21', max_value: '40' },
          { min_value: '41', max_value: '60' },
          { min_value: '61', max_value: '80' },
          { min_value: '81', max_value: '100' },
          { min_value: '101', max_value: '120' },
          { min_value: '121', max_value: '140' },
          { min_value: '141', max_value: '160' },
          { min_value: '161', max_value: '180' },
          { min_value: '181', max_value: '200' },
        ])
        if (respOption) {
          respOption.map((data) => {
            if (data.code == value.toLowerCase() && data.options != null) {
              var stateOptions = { ...selectOption }
              stateOptions['condition'] = data.options.target_condition;
              setSelectOption(stateOptions)
            }
          })
        }
      } else if (value == 'Date') {
        setUnit(null)
        setCondition(null)
        setTargetValue(endDate != null ? dayjs(endDate).format('DD/MM/YYYY') : "")
        setScaleCondition([
          { min_value: '01/01/2020', max_value: '31/01/2020' },
          { min_value: '01/02/2020', max_value: '28/02/2020' },
          { min_value: '01/03/2020', max_value: '31/03/2020' },
          { min_value: '01/04/2020', max_value: '30/04/2020' },
          { min_value: '01/05/2020', max_value: '31/05/2020' },
          { min_value: '01/06/2020', max_value: '30/06/2020' },
          { min_value: '01/07/2020', max_value: '31/07/2020' },
          { min_value: '01/08/2020', max_value: '31/08/2020' },
          { min_value: '01/09/2020', max_value: '30/09/2020' },
          { min_value: '01/10/2020', max_value: '31/10/2020' },
        ])
      } else if (value == 'Accomplishment') {
        setUnit(null)
        setCondition(null)
        setTargetValue('Success')
      }
    } else if (type == 'unit') {
      setOthers("")
      setUnit(value)
      setScaleCondition([
        { min_value: '1', max_value: '20' },
        { min_value: '21', max_value: '40' },
        { min_value: '41', max_value: '60' },
        { min_value: '61', max_value: '80' },
        { min_value: '81', max_value: '100' },
        { min_value: '101', max_value: '120' },
        { min_value: '121', max_value: '140' },
        { min_value: '141', max_value: '160' },
        { min_value: '161', max_value: '180' },
        { min_value: '181', max_value: '200' },
      ])
      if (value.code == 'Minute') {
        setScaleCondition([
          { min_value: '1', max_value: '20' },
          { min_value: '21', max_value: '30' },
          { min_value: '31', max_value: '40' },
          { min_value: '41', max_value: '50' },
          { min_value: '51', max_value: '60' },
          { min_value: '61', max_value: '70' },
          { min_value: '71', max_value: '80' },
          { min_value: '81', max_value: '90' },
          { min_value: '91', max_value: '100' },
        ])
      } else if (value.code == 'Hours') {
        setScaleCondition([
          { min_value: '1', max_value: '4' },
          { min_value: '5', max_value: '8' },
          { min_value: '9', max_value: '12' },
          { min_value: '13', max_value: '16' },
          { min_value: '17', max_value: '24' },
          { min_value: '17', max_value: '24' },
        ])
      } else if (value.code == 'Score') {
        setScaleCondition([
          { min_value: '1', max_value: '200' },
          { min_value: '201', max_value: '400' },
          { min_value: '401', max_value: '600' },
          { min_value: '601', max_value: '800' },
          { min_value: '801', max_value: '1000' },
          { min_value: '1001', max_value: '1200' },
        ])
      }
    } else if (type === 'condition') {
      setCondition(value)
    } else if (type === 'memberType') {
      setMemberType(value)
      stateOption['member'] = memberOption
      setSelectOption(stateOption);
    } else if (type === 'member') {
      setMember(value)
    } else if (type === 'permission') {
      setPermission(value)
    } else if (type === 'type') {
      if (goalAlignment === 2) {
        stateOption['value'] = value == 'Member' ? memberOption : memberTeamOption
      }
      setType(value)
    } else if (type == 'value') {
      setValue(value)
    }
  };

  const changeMoreDetail = (value, item, idx) => {
    let moreDetailStruct = [...moreDetail]

    if (item.type === 'text') {
      item.value = value;
      moreDetailStruct[idx] = item;
    } else if (item.type === 'dropdown') {
      item.value = value;
      moreDetailStruct[idx] = item;
    } else if (item.type === 'textarea') {
      item.value = value;
      moreDetailStruct[idx] = item;
    } else if (item.type === 'number') {
      if (value === null || value === "") {
        item.value = "";
      } else {
        item.value = value.replace(/[^\d.]|\.(?=.*\.)/g, '');
      }
      moreDetailStruct[idx] = item;
    }

    setMoreDetail(moreDetailStruct)
  }

  const changeValue = (value, type) => {
    if (type === 'name') {
      setGoalName(value)
    } else if (type === 'detail') {
      setGoalDetail(value)
    } else if (type == 'measurement') {
      setMeasurement(value)
    } else if (type === 'others') {
      setOthers(value)
    } else if (type === 'targetValue') {
      value = value.replace(/[^\d.]|\.(?=.*\.)/g, '')
      setTargetValue(value)
    } else if (type === 'weight') {
      if (value && value.indexOf('.') > 0) {
        const idxDot = value.indexOf('.');
        if (idxDot + 1 === value.length) {
          setWeight(value)
        }
        if (idxDot + 2 === value.length) {
          setWeight(parseFloat(value).toFixed(1))
        }
      } else if (value === null || value === "") {
        setWeight(null)
      } else {
        setWeight(value.replace(/[^\d.]|\.(?=.*\.)/g, ''))
      }
    }
  }

  const changeScaleLevel = (value, type, idx) => {
    var scaleLevelData = [...scaleLevel];

    if (goalMetric === 'Date') {
      // console.log(value)
      if (type == `scaleMin`) {
        scaleLevelData[idx]['min_value'] = dayjs(value).format('MM/DD/YYYY')
        // console.log('min', scaleLevelData[idx]['min_value'])
      } else if (type == `scaleMax`) {
        scaleLevelData[idx]['max_value'] = dayjs(value).format('MM/DD/YYYY')
        // console.log('max', scaleLevelData[idx]['max_value'])
      }
    } else if (goalMetric === 'Value') {
      if (type == `scaleMin`) {
        let min;
        const idxDot = value.split('.');
        if (value && value.indexOf('.') > 0) {
          if (idxDot[1] && idxDot[1].length === 1) {
            min = value
          } else if (idxDot[1] && idxDot[1].length === 2) {
            min = parseFloat(value).toFixed(2)
          } else if (idxDot[1] && idxDot[1].length === 3) {
            min = parseFloat(value).toFixed(3)
          } else if (idxDot[1] && idxDot[1].length === 4) {
            min = parseFloat(value).toFixed(4)
          }
        } else if (value === null || value === "") {
          min = ""
        }
        if (idxDot[1] && idxDot[1].length > 0) {
          if (min)
            min = min.replace(/[^\d.]|\.(?=.*\.)/g, '')
          else
            min = value.substr(0, value.length - 1).replace(/[^\d.]|\.(?=.*\.)/g, '')
        } else {
          min = value.replace(/[^\d.]|\.(?=.*\.)/g, '')
        }
        scaleLevelData[idx]['min_value'] = min
      } else if (type == `scaleMax`) {
        let max;
        const idxDot = value.split('.');
        if (value && value.indexOf('.') > 0) {
          if (idxDot[1] && idxDot[1].length === 1) {
            max = value
          } else if (idxDot[1] && idxDot[1].length === 2) {
            max = parseFloat(value).toFixed(2)
          } else if (idxDot[1] && idxDot[1].length === 3) {
            max = parseFloat(value).toFixed(3)
          } else if (idxDot[1] && idxDot[1].length === 4) {
            max = parseFloat(value).toFixed(4)
          }
        } else if (value === null || value === "") {
          max = ""
        }
        if (idxDot[1] && idxDot[1].length > 0) {
          if (max)
            max = max.replace(/[^\d.]|\.(?=.*\.)/g, '')
          else
            max = value.substr(0, value.length - 1).replace(/[^\d.]|\.(?=.*\.)/g, '')
        } else {
          max = value.replace(/[^\d.]|\.(?=.*\.)/g, '')
        }
        scaleLevelData[idx]['max_value'] = max
      }
    }

    setScaleLevel(scaleLevelData)
  }

  const valueCondition = () => {
    let text = ''
    if (unit === 'Percentage') {
      text = "0.00 - 100.00"
    } else if (unit === 'Minute') {
      text = "0.00 - 100.00"
    } else if (unit === 'Hour') {
      text = "0.00 - 100.00"
    } else if (unit === 'Day') {
      text = "0.00 - 100.00"
    } else if (unit === 'Score') {
      text = "0 - 1,000.00"
    } else if (unit === 'Client') {
      text = "0 - 100,000.00"
    } else if (unit === 'Count') {
      text = "0 - 100,000.00"
    } else if (unit === 'THB') {
      text = "0 - 1,000,000,000.00"
    } else if (unit === 'USD') {
      text = "0 - 1,000,000,000.00"
    } else if (unit === 'Others') {
      text = "0 - 1,000,000,000.00"
    }
    return <Typography style={{ fontSize: 14, color: '#404349' }}>{text}</Typography>
  }

  const addDate = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const setValueFromAnotherPage = () => {
    if (state) {
      console.log('setValueFromAnotherPage', state)
      if ((state?.name || state?.goalName) ?? false) setGoalName(state.name ?? state.goalName);
      if ((state?.description || state?.goalDetail) ?? false) setGoalDetail(state.description ?? state.goalDetail);
      if (state?.metric ?? false) {
        var metric = (state.metric.description === 'ทำได้ตัวเลขตามเป้าหมาย' || state.metric.description === 'Value') ? 'Value' : (state.metric.description === 'ทำได้ภายใน End Date' || state.metric.description === 'Date') ? 'Date' : 'Accomplishment'
        handleChange(metric, 'metric')
      }
      if (state?.serial ?? false) setEvaluatorSerial(state.serial)
      if (state?.cycleSerial ?? false) setCycleSerial(state.cycleSerial)
      if (state?.condition ?? false) setCondition(state.condition);
      // if(state?.evaluator) {
      //   setEvaluator(state?.evaluator?.full_name);
      // }
      if (state?.goalCategory ?? false) setCategory(state.goalCategory);
      // if(state?.start_date) setStartDate(Util.formatDate2(state.start_date));
      // if(state?.end_date) setEndDate(Util.formatDate2(state.end_date));
      if (state?.goalType ?? false) setGoalType(state.goalType);
      if (state?.type ?? false) {
        setGoalType(state?.type?.code === 'team' ? 2 : state?.type.code === 'personal' ? 3 : 1)
      }
      if (state?.member ?? false) setMember(state.member);
      if (state?.memberType ?? false) setMemberType(state.memberType);
      // if(state?.others ?? false) setOthers(state.others);
      if (state?.permission ?? false) setPermission(state.permission);
      if (state?.target_value ?? false) setTargetValue(state.target_value)
      if (state?.weight ?? false) setWeight(state?.weight);
      if (state?.scaleLevel ?? false) setScaleLevel(state.scaleLevel);
      if (state?.categoryWeight ?? false) setCategoryWeight(state.categoryWeight)
      if (state?.selectOption ?? false) setSelectOption(state.selectOption)
      // setGoalCategoryOptions(state.goalCategoryOptions)
      if (state?.memberTeamOption ?? false) setMemberTeamOption(state.memberTeamOption)
      if (state?.memberOption ?? false) setMemberOption(state.memberOption)
    }
  }

  const setValueFromForEdit = (data) => {
    //console.log('setValueFromForEdit', data)
    const goalDetailEdit = data;

    setGoalData(goalDetailEdit?.goal_detail)
    setGoalTemplateSerial(goalDetailEdit?.goal_template_id)
    if (Object.keys(goalDetailEdit).length > 0) {
      if (goalDetailEdit?.goal_detail?.unit) {
        setUnit(goalDetailEdit?.goal_detail?.unit)
      }
      if (goalDetailEdit?.goal_detail?.specify_unit) {
        setOthers(goalDetailEdit?.goal_detail?.specify_unit)
      }
      if (goalDetailEdit?.goal_detail?.target_condition) {
        setCondition(goalDetailEdit?.goal_detail?.target_condition.charAt(0).toUpperCase() + goalDetailEdit?.goal_detail?.target_condition.slice(1))
      }
      if (goalDetailEdit?.goal_category?.kpi_goal_template_category_id) {
        chooseCategory(goalDetailEdit?.goal_category?.kpi_goal_template_category_id);
        setBackupCategory(goalDetailEdit?.goal_category?.kpi_goal_template_category_id);
        setBackupWeight(100);
      }

      if (goalDetailEdit?.scale_level?.length > 0) {
        let saveScale = [];
        goalDetailEdit?.scale_level?.map((item) => {
          var valueMin = item.value_min;
          var valueMax = item.value_max;
          if (valueMin.indexOf('/') > 0) {
            var splitValue = valueMin.split('/')
            valueMin = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
          }
          if (valueMax.indexOf('/') > 0) {
            var splitValue = valueMax.split('/')
            valueMax = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
          }
          saveScale.push({ min_value: valueMin, max_value: valueMax, serial: item.serial, level: item.level })
        })
        setScaleLevel(saveScale)
        setScaleLevelCheckbox(true);
      }
      if (goalDetailEdit?.linking_goal?.link_data) {
        if (goalAlignment !== 1) {
          if (goalDetailEdit?.linking_goal?.linking_goal_type === 'linking_associate') {
            setType('Associated Goal')
          } else {
            setType('Parent Goal')
          }
          setValue(goalDetailEdit?.linking_goal?.alignment_id)
          setGoalAlignment(1)
        }
      }
      if (goalDetailEdit?.kpi_goal_id) {
        setKpiGoalId(goalDetailEdit?.kpi_goal_id)
      }
      if (goalDetailEdit?.evaluator_permission?.evaluator) {
        setEvaluator(goalDetailEdit?.evaluator_permission?.evaluator)
      }
      if (goalDetailEdit?.goal_detail?.start_date) {
        setStartDate(goalDetailEdit?.goal_detail?.start_date)
      }
      if (goalDetailEdit?.goal_detail?.end_date) {
        setEndDate(goalDetailEdit?.goal_detail?.end_date)
      }

      // New Data
      if (goalDetailEdit?.goal_detail?.measurement) {
        setMeasurement(goalDetailEdit?.goal_detail?.measurement)
      }
      if (goalDetailEdit?.more_detail?.length > 0) {
        setMoreDetail(goalDetailEdit?.more_detail)
      }
    }
  }

  const changeAlignment = (val) => {
    if (val != goalAlignment) {
      var stateOption = { ...selectOption };
      setType("")
      if (val == 1) {
        stateOption['type'] = ['Associated Goal', 'Parent Goal'];
        stateOption['value'] = alignmentOption;
        setValue(null)
      } else {
        stateOption['type'] = ['Member', 'Team'];
        stateOption['value'] = [];
        setValue([])
      }
      setSelectOption(stateOption)
    }
    setGoalAlignment(val)
  }

  const requireField = (text) => {
    return (
      <Grid container direction="row">
        <Grid>
          <Typography style={{ fontSize: '18px', color: '#404349', fontWeight: '500' }}>{text}</Typography>
        </Grid>
        <Grid>
          <Typography style={{ color: '#cc6058', fontSize: '18px', fontWeight: 500 }}>&nbsp;*</Typography>
        </Grid>
      </Grid>)
  }

  const warningMessage = (bool, text) => {
    return (
      bool &&
      <Grid container direction="row">
        <Grid item>
          <Typography style={{ fontSize: '14px', color: '#CC6058', fontWeight: '500', fontFamily: 'Kanit' }}>{text ? text : t("corporateGoal.label.form.warningFill")}</Typography>
        </Grid>
      </Grid>
    )
  }

  const handleConfirmApprove = (val) => {
    openApproveDialog(false);
    if (id === 'edit') {
      goto('/manage-corporate-goal')
    } else {
      goto('/manage-corporate-goal/create', state)
    }
  }

  const handleConfirmApproveDialog = (val) => {
    openApproveDialog(val);
  }
  // Varify & Set Data End

  const checkedAllOfList = (selectList, search) => {
    const listOfSearch = memberOption.filter((item) => {
      if (item?.code.indexOf(search) >= 0 ||
        item?.firstName.indexOf(search) >= 0 ||
        item?.lastName.indexOf(search) >= 0 ||
        item?.empSubName.indexOf(search) >= 0 ||
        item?.empName.indexOf(search) >= 0) {
        return item
      }
    })

    let checked = true;
    if (selectList.length > 0) {
      const searchedList = listOfSearch.filter(object1 => {
        return !selectList.some(object2 => {
          return object1.code === object2.code;
        });
      });
      if (searchedList.length !== 0) {
        checked = false;
      }
    } else {
      checked = false
    }

    return checked;
  }

  const unCheckAllOfList = (selectList, search) => {
    const listOfSearch = memberOption.filter((item) => {
      if (item?.code.indexOf(search) >= 0 ||
        item?.firstName.indexOf(search) >= 0 ||
        item?.lastName.indexOf(search) >= 0 ||
        item?.empSubName.indexOf(search) >= 0 ||
        item?.empName.indexOf(search) >= 0) {
        return item
      }
    })

    let notUncheck = false;
    if (selectList.length === listOfSearch.length) {
      selectList.filter((item) => {
        var fact = listOfSearch.some((item2) => item.code === item2.code)
        if (fact === false) {
          notUncheck = true
        }
      })
    }

    if (notUncheck) {
      return selectList;
    } else {
      return [];
    }
  }

  const checkScaleLevel = () => {
    setScaleLevelCheckbox(!scaleLevelCheckbox)
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const formatScaleDate = (date) => {
    let newDate = date.split("/")
    return `${newDate[1]}-${newDate[0]}-${newDate[2]}`
  }

  // Function End

  // Variable Start
  const [verifyField, setVerifyField] = React.useState({})
  const [goalType, setGoalType] = React.useState()
  const [goalCategory, setCategory] = React.useState(null)
  const [goalName, setGoalName] = React.useState(null)
  const [goalDetail, setGoalDetail] = React.useState(null)
  const [goalData, setGoalData] = React.useState(null)
  const [startDate, setStartDate] = React.useState(Util.formatDate(new Date()))
  const [endDate, setEndDate] = React.useState(Util.formatDate(Util.subStractDate(new Date(), "add", 1)))
  const [targetValue, setTargetValue] = React.useState(null)
  const [weight, setWeight] = React.useState(null)
  const [others, setOthers] = React.useState(null)
  const [measurement, setMeasurement] = React.useState(null)
  const [evaluator, setEvaluator] = React.useState(null)
  const [goalMetric, setGoalMetric] = React.useState(null)
  const [unit, setUnit] = React.useState(null)
  const [condition, setCondition] = React.useState(null)
  const [memberType, setMemberType] = React.useState(null)
  const [member, setMember] = React.useState([])
  const [minDate, setMinDate] = React.useState(Util.formatDate(new Date()));
  const [maxDate, setMaxDate] = React.useState(Util.formatDate(new Date()));
  const [maxEndDate, setMaxEndDate] = React.useState(Util.formatDate(new Date()));
  const [permission, setPermission] = React.useState("Public")
  const [scaleLevel, setScaleLevel] = React.useState([
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
  ])
  const [categoryWeight, setCategoryWeight] = React.useState(100)
  const [canCascading, setCancascading] = React.useState(false)
  const [scaleCondition, setScaleCondition] = React.useState([
    { min_value: '1', max_value: '20' },
    { min_value: '21', max_value: '40' },
    { min_value: '41', max_value: '60' },
    { min_value: '61', max_value: '80' },
    { min_value: '81', max_value: '100' },
    { min_value: '101', max_value: '120' },
    { min_value: '121', max_value: '140' },
    { min_value: '141', max_value: '160' },
    { min_value: '161', max_value: '180' },
    { min_value: '181', max_value: '200' },
  ])
  const [selectOption, setSelectOption] = React.useState({
    goalMetric: [],
    goalType: [],
    condition: [],
    unit: [],
    evaluator: [],
    member: [],
    memberType: [],
    permission: [],
  })
  const [respOption, setRespOption] = React.useState(null)
  const [goalCategoryOptions, setGoalCategoryOptions] = React.useState([])
  const [memberTeamOption, setMemberTeamOption] = React.useState([])
  const [memberOption, setMemberOption] = React.useState([])
  const [orderScale, setOrderScale] = React.useState('asc');
  const [isApproveDialogOpen, openApproveDialog] = React.useState(false);
  const [isConfirmEditOpen, openConfirmEditOpen] = React.useState(false);
  const [isSuccessEditOpen, openSuccessEditOpen] = React.useState(false);
  const [evaluatorSerial, setEvaluatorSerial] = React.useState(null);
  const [isSearchMember, setIsSearchMember] = React.useState(false);
  const [isSearchAlignment, setIsSearchAlignment] = React.useState(false);
  const [teamSearch, setTeamSearch] = React.useState(null);
  const [alignmentSearch, setAlignmentSearch] = React.useState(null);
  const [goalAlignment, setGoalAlignment] = React.useState(0)
  const [type, setType] = React.useState("")
  const [value, setValue] = React.useState(null);
  const [alignmentOption, setAlignmentOption] = React.useState([])
  const [alignmentList, setAlignmentList] = React.useState([])
  const [originalAlignment, setOriginalAlignment] = React.useState(null)
  const [scaleLevelCheckbox, setScaleLevelCheckbox] = React.useState(false)
  const [checkedMember, setCheckedMember] = React.useState(false)
  const [checkedAlignment, setCheckedAlignment] = React.useState(false)
  const [goalTemplateSerial, setGoalTemplateSerial] = React.useState("")
  const [cycleSerial, setCycleSerial] = React.useState(null)
  const [kpiGoalId, setKpiGoalId] = React.useState(null)
  const [editFirstCome, setEditFirstCome] = React.useState(true)
  const [fetchFirstCome, setFetchFirstCome] = React.useState(true)
  const [respFirstCome, setRespFirstCome] = React.useState(true)
  const [backupCategory, setBackupCategory] = React.useState(null)
  const [backupWeight, setBackupWeight] = React.useState(null)
  const [isOwner, setIsOwner] = React.useState(true)
  const [moreDetail, setMoreDetail] = React.useState([])

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState("");
  const headerMember = [
    { field: 'code', headerName: 'Employee Code', width: 50 },
    { field: 'firstName', headerName: 'Name', width: 100 },
    { field: 'empSubName', headerName: 'Position', width: 100 },
    { field: 'empName', headerName: 'Team', width: 100 },
    { field: '', headerName: '', width: 50 },
  ]

  // Variable End

  useEffect(() => {
    if (fetchFirstCome && cycleSerial) {
      var stateOption = { ...selectOption };
      stateOption['memberType'] = ['Team', 'Member'];
      stateOption['permission'] = ['Private', 'Line', 'Team'];

      dispatch(getDropdownMetric())
        .then(resp => {
          if (Object.keys(resp).length > 0) {
            var metric = resp.metric.map((item) => { return item.code.charAt(0).toUpperCase() + item.code.slice(1) })
            stateOption['goalMetric'] = metric;
            var targetCon = resp.metric.filter((item) => item.options !== null && item.code === 'value')
            stateOption['condition'] = targetCon[0].options.target_condition;
            setRespOption(resp.metric)
          }
        })

      dispatch(getDropdownUnit())
        .then(resp => {
          if (Object.keys(resp).length > 0) {
            stateOption['unit'] = resp.unit;
            stateOption['unitOption'] = resp.unit;
            if (unit != null) {
              const unitList = resp?.unit?.find((item) => item.serial = unit)
              setUnit(unitList)
            }
          }
        })

      dispatch(getGoalType(cycleSerial ?? ""))
        .then(resp => {
          const corpGoalType = resp.data.goalTypeList.filter((item) => item.code === 'corporate')[0]
          setGoalType(corpGoalType.serial ?? "")
        })

      dispatch(getGroupCategory(cycleSerial ?? ""))
        .then(resp => {
          setGoalCategoryOptions(resp.data.goalCategory);
        })

      var scaleObject = []
      dispatch(getScaleLevel(cycleSerial ?? ""))
        .then(resp => {
          resp.data.goalScaleLevel?.map((item, key) => {
            scaleObject.push({ min_value: null, max_value: null, serial: item.serial, level: item.level })
          })
          setScaleLevel(scaleObject)
        })

      dispatch(getCustomForm(cycleSerial ?? ""))
        .then(resp => {
          if (resp.data.length > 0) {
            let data = resp.data;
            if (data?.options && data?.options?.default !== undefined) {
              data.value = data?.options?.default
            }
            setMoreDetail(data);
          }
        })

      dispatch(getAlignmentList(cycleSerial ?? ""))
        .then(resp => {
          stateOption['type'] = ['Associated Goal', 'Parent Goal'];
          stateOption['value'] = resp.data.list_goal;
          setAlignmentOption(resp.data.list_goal)
        })
      setFetchFirstCome(false);
      setSelectOption(stateOption);

      if (id === 'edit' && editFirstCome) {
        dispatch(getGoalForEdit(state.goalSerial))
          .then(resp => {
            setValueFromForEdit(resp?.data?.goal_detail)
            setEditFirstCome(false)
          })
      }
    }
  }, [fetchFirstCome, cycleSerial, editFirstCome]);

  useEffect(() => {
    if (respFirstCome) {
      setValueFromAnotherPage();
      setRespFirstCome(false)
    }
  }, [respOption])

  useEffect(() => {
    if (state.category && state.category !== "") setPreSelectCategory(state.category)
  }, [state, goalCategoryOptions])

  useEffect(() => {
    // console.log(unit)
  }, [unit])

  useEffect(() => {
    if (goalData?.goal_metric_label) {
      setGoalMetric(goalData?.goal_metric_label)
    }

    if (goalData?.goal_name) setGoalName(goalData?.goal_name)
    if (goalData?.goal_details) setGoalDetail(goalData?.goal_details)
    if (goalData?.measurement) setMeasurement(goalData?.measurement)
    if (goalData?.weight) setWeight(goalData?.weight)
    if (goalData?.target_value) setTargetValue(goalData?.target_value)

  }, [goalData])

  return (
    <>
      <Helmet>
        <title> Corporate Goal </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => navigate("/kpi/home")}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('/manage-corporate-goal')}>
                {` ${t('corporateGoal.label.title')}`}
              </span> /
              <span style={styles.end} >
                {id === 'edit' ? ` ${t('corporateGoal.label.editGoal')}` : ` ${t('corporateGoal.label.createGoal')}`}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container textAlign="center">
            <Grid item md={12} >
              <Typography fontSize={32} lineHeight="39.6px" fontWeight="600" color="#404349">
                {
                  id === 'edit'
                    ? t('corporateGoal.label.edit')
                    : t('corporateGoal.label.detail')
                }
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16} color="#404349" fontWeight={400}>
                {t('corporateGoal.label.detailDesc')}
              </Typography>
            </Grid>
          </Grid>
          <Box ref={goalDetailRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
            <Grid container>
              <Grid item mb={2}>
                <Typography fontSize={22} lineHeight="39.6px" fontWeight="600" color="#404349">
                  {t("corporateGoal.label.goalDetail")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} ml={2} pr={5}>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.goalName"))}
                </Typography>
              </Grid>
              <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <TextField error={verifyField.name} onChange={(e) => changeValue(e.target.value, 'name')}
                  id="outlined-basic" placeholder={t("corporateGoal.label.form.fillGoalName")} value={goalName} variant="outlined"
                  required fullWidth size="small"
                  style={{ WebkitTextFillColor: !goalName ? '#AAAAAA' : '#404349', fontWeight: !goalName ? '300' : '400', fontSize: '16px', borderColor: verifyField.name ? '#CC6058' : '#e1e1e1', paddingTop: '7px' }} />
                {(verifyField.name && !goalName) &&
                  warningMessage(verifyField.name)
                }
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.goalDetail"))}
                </Typography>
              </Grid>
              <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <TextField
                  multiline
                  fullWidth
                  rows={4}
                  placeholder={t("corporateGoal.label.form.descGoalDetail")}
                  style={{
                    borderColor: verifyField.detail ? '#FF0000' : '#c3c2c2', opacity: !goalDetail === null ? 0.5 : 1, width: '100%',
                    font: 'inherit', fontFamily: 'Kanit', resize: 'none', outlineColor: '#5DA196', borderRadius: '4px',
                    WebkitTextFillColor: !goalDetail ? '#AAAAAA' : '#404349', fontWeight: !goalDetail ? '300' : '400', fontSize: '16px',
                    borderColor: verifyField.detail ? '#CC6058' : '#e1e1e1'
                  }}
                  value={goalDetail}
                  error={verifyField.detail && !goalDetail}
                  onChange={(e) => changeValue(e.target.value, 'detail')}
                />
                {(verifyField.detail && !goalDetail) &&
                  warningMessage(verifyField.detail)
                }
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.measurement"))}
                </Typography>
              </Grid>
              <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <TextField
                  multiline
                  rows={2}
                  error={verifyField.measurement} onChange={(e) => changeValue(e.target.value, 'measurement')}
                  id="outlined-basic" placeholder={t('mygoal.placeholder.measurement')} value={measurement} variant="outlined"
                  required fullWidth size="small"
                  style={{ WebkitTextFillColor: !measurement ? '#A3A3A3' : '#404349', fontWeight: !measurement ? '300' : '400', fontSize: '16px', borderColor: verifyField.measurement ? '#CC6058' : '#e1e1e1', paddingTop: '7px' }}
                  disabled={!isOwner}
                  sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : {}}
                />
                {(verifyField.measurement && !measurement) &&
                  warningMessage(verifyField.measurement)
                }
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.startDate"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.endDate"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    format="dd/MM/yyyy"
                    value={startDate}
                    disabled={false}
                    onChange={(newValue) => {
                      if (newValue) {
                        setStartDate(Util.formatDate(newValue));
                      } else {
                        setStartDate(null)
                      }
                    }}
                    style={{ color: '#404349', fontWeight: !startDate ? '300' : '400', fontSize: '16px', borderColor: verifyField.startDate ? '#CC6058' : '#e1e1e1' }}
                    inputProps={{
                      placeholder: t("corporateGoal.label.form.selectStartDate"), sx: {
                        "&::placeholder": {
                          color: "#AAAAAA"
                        }
                      }
                    }}
                    renderInput={(params) => <TextField {...params}
                      fullWidth
                      size="small"
                      error={verifyField.startDate && !startDate}
                    />
                    }
                  />
                </LocalizationProvider>
                {(verifyField.startDate && !startDate) &&
                  warningMessage(verifyField.startDate)
                }
              </Grid>
              <Grid lg={6} xs={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    format="dd/MM/yyyy"
                    value={endDate}
                    disabled={false}
                    minDate={addDate(startDate, 0)}
                    onChange={(newValue) => {
                      if (newValue) {
                        setEndDate(Util.formatDate(newValue));
                        if (goalMetric == 'Date') {
                          setTargetValue(dayjs(newValue).format('DD/MM/YYYY'))
                        }
                      } else {
                        setEndDate(null)
                        if (goalMetric == 'Date') {
                          setTargetValue(null)
                        }
                      }
                    }}
                    style={{ color: '#404349', fontWeight: endDate === null ? '300' : '400', fontSize: '16px', borderColor: verifyField.endDate ? '#CC6058' : '#e1e1e1' }}
                    inputProps={{
                      placeholder: t("corporateGoal.label.form.selectEndDate"), sx: {
                        "&::placeholder": {
                          color: "#AAAAAA"
                        }
                      }
                    }}
                    renderInput={(params) => <TextField {...params}
                      fullWidth
                      size="small"
                      error={verifyField.endDate}
                    />
                    }
                  />
                </LocalizationProvider>
                {(verifyField.endDate && endDate === null) &&
                  warningMessage(verifyField.endDate)
                }
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.labelGoalMetric"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.targetCondition"))}
                </Typography>
              </Grid>
              <Grid lg={6} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <FormControl sx={{ minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.goalMetric}
                    labelId="metric"
                    id="metric"
                    input={<OutlinedInput size="small" />}
                    value={goalMetric}
                    onChange={(val) => { handleChange(val.target.value, 'metric') }}
                    style={{ borderColor: verifyField.goalMetric ? '#CC6058' : '#e1e1e1' }}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <Typography style={{ color: goalMetric === null ? '#AAAAAA' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: goalMetric === null ? '300' : '400', fontSize: '16px' }}> {t("corporateGoal.label.form.selectMetric")} </Typography>;
                      } else {
                        return selected
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <Typography style={{ color: goalMetric === null ? '#AAAAAA' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: goalMetric === null ? '300' : '400', fontSize: '16px' }}>{t("corporateGoal.label.form.selectMetric")}</Typography>
                    </MenuItem>
                    {selectOption?.goalMetric?.map((option, idx) => {
                      return <MenuItem key={idx} value={option}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option}</Typography></MenuItem>
                    })}
                  </Select>
                </FormControl>
                {(verifyField.goalMetric && goalMetric === null) &&
                  warningMessage(verifyField.goalMetric)
                }
              </Grid>
              <Grid lg={6} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <FormControl sx={{ minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.condition}
                    disabled={goalMetric != 'Value'}
                    classes={goalMetric != 'Value' ? { select: classes.disabled } : {}}
                    labelId="condition"
                    id="condition"
                    value={condition}
                    style={{ borderColor: verifyField.condition ? '#CC6058' : '#e1e1e1' }}
                    onChange={(val) => { handleChange(val.target.value, 'condition') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <Typography style={{ color: condition === null ? '#AAAAAA' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: condition === null ? '300' : '400', fontSize: '16px' }}>{goalMetric != 'Value' ? '' : t("corporateGoal.label.form.selectTargetCondition")}</Typography>;
                      } else {
                        return selected
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <Typography style={{ color: condition === null ? '#AAAAAA' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: condition === null ? '300' : '400', fontSize: '16px' }}>{t("corporateGoal.label.form.selectTargetCondition")}</Typography>
                    </MenuItem>
                    {selectOption?.condition?.map((option, idx) => {
                      return <MenuItem key={idx} value={option.label}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.label}</Typography></MenuItem>
                    })}
                  </Select>
                </FormControl>
                {(verifyField.condition && condition === null) &&
                  warningMessage(verifyField.condition)
                }
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.unit"))}
                </Typography>
              </Grid>
              <Grid lg={4} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.targetValue"))}
                </Typography>
              </Grid>
              <Grid lg={2} xs={12} item style={{ textAlign: 'right', alignItems: 'flex-end' }}>
                {valueCondition()}
              </Grid>
              <Grid lg={6} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <FormControl sx={{ minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.unit}
                    labelId="unit"
                    id="unit"
                    value={unit}
                    disabled={goalMetric != 'Value'}
                    classes={goalMetric != 'Value' ? { select: classes.disabled } : {}}
                    onChange={(val) => { handleChange(val.target.value, 'unit') }}
                    input={<OutlinedInput size="small" />}
                    style={{ borderColor: verifyField.unit ? '#CC6058' : '#e1e1e1' }}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <Typography style={{ color: !unit ? '#AAAAAA' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: !unit ? '300' : '400', fontSize: '16px' }}>{goalMetric != 'Value' ? '' : t("corporateGoal.label.form.selectTargetUnit")}</Typography>;
                      } else {
                        return selectOption?.unit?.find((item) => (item.serial === selected || item.description === selected))?.description
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <Typography style={{ color: !unit ? '#AAAAAA' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: !unit ? '300' : '400', fontSize: '16px' }}> {t("corporateGoal.label.form.selectTargetUnit")} </Typography>
                    </MenuItem>
                    {selectOption?.unit?.map((option, idx) => {
                      return <MenuItem key={idx} value={option.code === 'custom' ? 'Custom' : option.serial}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.description}</Typography></MenuItem>
                    })}
                  </Select>
                </FormControl>
                {(verifyField.unit && !unit) &&
                  warningMessage(verifyField.unit)
                }
              </Grid>
              <Grid lg={6} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <TextField
                  error={verifyField.targetValue}
                  disabled={goalMetric != 'Value'}
                  id="targetValue"
                  placeholder={goalMetric === 'Value' ? t("corporateGoal.label.form.fillTargetValue") : ''}
                  variant="outlined"
                  value={targetValue}
                  onChange={(e) => changeValue(e.target.value, 'targetValue')}
                  required
                  fullWidth
                  size="small"
                  sx={goalMetric === 'Value' ? {} : { input: { backgroundColor: '#F3F3F3!important' } }}
                  style={{ color: '#404349', fontWeight: !targetValue ? '300' : '400', fontSize: '16px', borderColor: verifyField.targetValue ? '#CC6058' : '#e1e1e1' }}
                  inputProps={{
                    sx: {
                      "&::placeholder": {
                        color: "#AAAAAA"
                      }
                    }
                  }}
                />
                {(verifyField.targetValue && !targetValue) &&
                  warningMessage(verifyField.targetValue)
                }
              </Grid>
              {(unit === 'Custom' || unit === 'custom') &&
                <Grid container item lg={12}>
                  <Grid item xs="auto" display="flex" alignItems="center" mr={2}>
                    <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
                      <Typography fontSize="16px">
                        {t("corporateGoal.label.form.pleaseSpecify")}
                      </Typography>
                      <Typography sx={{ color: '#cc6058', fontSize: '18px', fontWeight: 500 }}>&nbsp;*</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2} display="flex" alignItems="center" flexDirection="column">
                    <Grid container item xs={12}>
                      <TextField id="others" placeholder={t("corporateGoal.label.specifyMeasureActivity")} variant="outlined" value={others} onChange={(e) => changeValue(e.target.value, 'others')} required fullWidth size="small"
                        style={{ WebkitTextFillColor: others === null ? '#AAAAAA' : '#404349', fontWeight: others === null ? '300' : '400', fontSize: '16px' }} error={verifyField.others && !others} />
                    </Grid>
                    <Grid container item xs={12}>
                      {
                        (verifyField.others && !others) &&
                        <Typography sx={{ fontSize: '14px', color: '#CC6058', fontWeight: '500', fontFamily: 'Kanit' }}>{t("corporateGoal.label.form.warningFill")}</Typography>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              }
            </Grid>
          </Box>
          {moreDetail.length > 0 &&
            <Box ref={moreDetailRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
              <MoreDetailCustom moreDetail={moreDetail} changeMoreDetail={changeMoreDetail} warningMessage={warningMessage} verifyField={verifyField} isOwner={isOwner} />
            </Box>
          }
          {goalMetric != null && goalMetric != 'Accomplishment' &&
            <Box ref={goalScaleRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
              <Grid container direction="row">
                <Grid item mb={2}>
                  <Checkbox {...label} mb={2} onClick={() => { checkScaleLevel() }} value={scaleLevelCheckbox} checked={scaleLevelCheckbox} />
                </Grid>
                <Grid item mb={2}>
                  <Typography fontSize={16} fontWeight={400} color="#404349">
                    {t("corporateGoal.label.form.setScaleLevel")}
                  </Typography>
                  <Typography fontSize={16} fontWeight={400} color="#AAAAAA">
                    {t("corporateGoal.label.form.scaleLevelSub")}
                  </Typography>
                </Grid>
              </Grid>
              {scaleLevelCheckbox === true &&
                <Grid container ml={5} pr={6}>
                  <Grid item>
                    <Typography fontSize={22} fontWeight={600}>
                      {requireField(t("corporateGoal.label.scaleLevel"))}
                    </Typography>
                  </Grid>
                  <Grid ml={1} container spacing={2} style={{ border: '1px solid #DADADA', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '13px', borderRadius: '10px' }} mt={3}>
                    <Grid md={2} item textAlign="center">
                      <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'} pl={0}>
                        {t("corporateGoal.label.level")}
                      </Typography>
                    </Grid>
                    <Grid md={2} item></Grid>
                    <Grid md={3} item textAlign="center">
                      <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'} pl={0}>
                        {t("corporateGoal.label.actualMin")}
                      </Typography>
                    </Grid>
                    <Grid md={1} item></Grid>
                    <Grid md={3} item textAlign="center">
                      <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'} pl={0}>
                        {t("corporateGoal.label.actualMax")}
                      </Typography>
                    </Grid>

                    {scaleLevel.map((scale, idx) => {
                      return (
                        <Grid container key={idx}>
                          <Grid md={12} item mt={1.5} mb={1.5}>
                            <Divider />
                          </Grid>
                          <Grid md={2} item textAlign="center">
                            <Typography variant="label" style={{ fontWeight: 400, fontSize: '18px', color: '#404349' }}>
                              {scale?.level}
                            </Typography>
                          </Grid>
                          <Grid md={2} item></Grid>
                          <Grid md={3} item>
                            {goalMetric == 'Date'
                              ?
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                  error={(verifyField.scaleLevelEmpty && (scale.min_value === null || !scale.min_value)) || verifyField.scaleLevel}
                                  format="dd/MM/yyyy"
                                  value={scale.min_value}
                                  onChange={(value) => changeScaleLevel(value, `scaleMin`, `${idx}`)}
                                  style={{ color: '#404349', fontWeight: endDate === null ? '300' : '400', fontSize: '16px' }}
                                  inputProps={{
                                    placeholder: t('mygoal.placeholder.startDate'), sx: {
                                      "&::placeholder": {
                                        color: '#A3A3A3'
                                      }
                                    }
                                  }}
                                  disabled={!isOwner}
                                  classes={!isOwner ? { select: classes.disabled } : {}}
                                  renderInput={(params) => <TextField {...params}
                                    fullWidth
                                    size="small"
                                    error={(verifyField.scaleLevelEmpty && (scale.min_value === null || !scale.min_value)) || verifyField.scaleLevel}
                                  />
                                  }
                                />
                              </LocalizationProvider>
                              :
                              <TextField id="outlined-basic" value={scale?.min_value} onChange={(e) => changeScaleLevel(e.target.value, `scaleMin`, `${idx}`)}
                                error={(verifyField.scaleLevelEmpty && (scale.min_value === null || !scale.min_value)) || verifyField.scaleLevel}
                                placeholder={scaleCondition[idx]?.min_value ? `${t('mygoal.etc.eg')} ${scaleCondition[idx]?.min_value}` : t('mygoal.placeholder.scaleLevel')} variant="outlined" required fullWidth size="small"
                                style={{ WebkitTextFillColor: scale?.min_value === null ? '#A3A3A3A70' : '#404349', fontWeight: '300', borderColor: scale?.min_value ? '#CED4DA' : '#FAFAFA', borderRadius: '4px' }}
                                disabled={!isOwner}
                                InputProps={{
                                  classes: {
                                    notchedOutline: styles.notchedOutline
                                  },
                                  className: !isOwner ? classes.disabled : null
                                }}
                              />
                            }
                            {(verifyField.scaleLevelEmpty && (scale.min_value === null || !scale.min_value)) &&
                              warningMessage(verifyField.scaleLevelEmpty)
                            }
                            {(verifyField.scaleLevel) &&
                              warningMessage(verifyField.scaleLevel, t('mygoal.label.overlap'))
                            }
                          </Grid>
                          <Grid md={1} item></Grid>
                          <Grid md={3} item>
                            {goalMetric == 'Date'
                              ?
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                  format="dd/MM/yyyy"
                                  value={scale.max_value}
                                  error={(verifyField.scaleLevelEmpty && (scale.max_value === null || !scale.max_value)) || verifyField.scaleLevel}
                                  onChange={(value) => changeScaleLevel(value, `scaleMax`, `${idx}`)}
                                  style={{ color: '#404349', fontWeight: scale.max_value === null ? '300' : '400', fontSize: '16px' }}
                                  inputProps={{
                                    placeholder: t('mygoal.placeholder.endDate'), sx: {
                                      "&::placeholder": {
                                        color: '#A3A3A3'
                                      }
                                    }
                                  }}
                                  disabled={!isOwner}
                                  classes={!isOwner ? { select: classes.disabled } : {}}
                                  renderInput={(params) => <TextField {...params}
                                    fullWidth
                                    size="small"
                                    error={(verifyField.scaleLevelEmpty && (scale.max_value === null || !scale.max_value)) || verifyField.scaleLevel}
                                  />
                                  }
                                />
                              </LocalizationProvider>
                              :
                              <TextField id="outlined-basic" value={scale?.max_value} onChange={(e) => changeScaleLevel(e.target.value, `scaleMax`, `${idx}`)}
                                error={(verifyField.scaleLevelEmpty && (scale.max_value === null || !scale.max_value)) || verifyField.scaleLevel}
                                placeholder={scaleCondition[idx]?.max_value ? `${t('mygoal.etc.eg')} ${scaleCondition[idx]?.max_value}` : t('mygoal.placeholder.scaleLevel')} variant="outlined" required fullWidth size="small"
                                style={{ WebkitTextFillColor: scale?.max_value === null ? '#A3A3A3A70' : '#404349', fontWeight: '300', borderColor: scale?.min_value ? '#CC6058' : '#e1e1e1', borderRadius: '4px' }}
                                disabled={!isOwner}
                                InputProps={{
                                  classes: {
                                    notchedOutline: styles.notchedOutline
                                  },
                                  className: !isOwner ? classes.disabled : null
                                }}
                              />
                            }
                            {(verifyField.scaleLevelEmpty && (scale.max_value === null || !scale.max_value)) &&
                              warningMessage(verifyField.scaleLevelEmpty)
                            }
                            {(verifyField.scaleLevel) &&
                              warningMessage(verifyField.scaleLevel, t('mygoal.label.overlap'))
                            }
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Grid>
              }
            </Box>
          }
          <Box ref={goalWeightRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 30 }} mb={3}>
            <Grid container mb={2} columnSpacing={2}>
              <Grid item xs="auto">
                <Typography fontSize={22} fontWeight={600} color={'#404349'}>
                  {t("corporateGoal.label.goalCategory")}
                </Typography>
              </Grid>
              {(verifyField.goalCategory && !goalCategory) &&
                <Grid item xs="auto" display="flex" alignItems="center">
                  <Typography style={{ fontSize: '14px', color: '#CC6058', fontWeight: '500', fontFamily: 'Kanit' }}>{t("corporateGoal.label.form.warningFill")}</Typography>
                </Grid>
              }
            </Grid>
            <Grid container spacing={2} ml="16px">
              {goalCategoryOptions?.map((categories, idx) => {
                return (
                  <Grid lg={1.5} xs={12} key={idx} item>
                    <Card style={goalCategory === categories.serial ? { border: `1px solid #5DA196`, cursor: 'pointer', height: '150px', width: '150px', borderRadius: 10 } : { border: `1px solid ${!goalCategory && isSubmitClicked ? '#cc6058' : '#DADADA'}`, cursor: 'pointer', height: '150px', width: '150px', borderRadius: 10 }} onClick={() => chooseCategory(categories.serial)}>
                      <CardContent style={{ padding: 0 }}>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Radio name="radio" value="1" checked={goalCategory === categories.serial} size="small" />
                          </Grid>
                          <Grid item lg={12}>
                            <Icon style={{ color: categories.color, fontSize: 50 }}>{categories.icon}</Icon>
                          </Grid>
                          <Grid item lg={12} mt={1}>
                            <BootstrapTooltip
                              placement="right"
                              arrow
                              title={categories.name}
                              style={{ marginLeft: '5px' }}
                            >
                              <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#404349"
                                sx={{
                                  display: '-webkit-box',
                                  overflow: 'hidden',
                                  WebkitBoxOrient: 'vertical',
                                  WebkitLineClamp: 2
                                }}
                              >
                                {categories.name}
                              </Typography>
                            </BootstrapTooltip>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )
              })}
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("corporateGoal.label.evaluatorWeight"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <Grid container direction="row">
                  <Grid lg={11}>
                    <TextField error={verifyField.weight && !weight} id="weight" placeholder={t("corporateGoal.label.form.fillEvaluationWeight")} value={weight} onChange={(e) => changeValue(e.target.value, 'weight')} variant="outlined" required fullWidth size="small"
                      style={{ marginTop: 8, borderColor: verifyField.weight ? '#CC6058' : '#e1e1e1', fontWeight: 400, fontSize: '16px', color: '#404349' }} />
                  </Grid>
                  <Grid ml={2} mt={2}>
                    <Typography style={{ fontWeight: 500, fontSize: '18px', color: '#404349' }}>
                      %
                    </Typography>
                  </Grid>
                  {(verifyField.weight && !weight) &&
                    warningMessage(verifyField.weight)
                  }
                </Grid>
              </Grid>
              {(!weight || weight === "0") &&
                <Grid lg={6}>
                </Grid>
              }
              {(categoryWeight - weight >= 0 && weight > 0) &&
                <Grid lg={6} alignSelf="center" style={{ paddingTop: '20px' }}>
                  <Grid container direction="row">
                    <Grid style={{ paddingRight: '5px' }}>
                      <Icon style={{ color: '#5DA196' }}>{'check_circle'}</Icon>
                    </Grid>
                    <Grid lg={11}>
                      <Typography style={{ color: '#5DA196' }}>
                        {t("corporateGoal.label.evaluatorSub")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              }
              {(categoryWeight - weight < 0 && weight > 0) &&
                <Grid lg={6} alignSelf="center" style={{ paddingTop: '20px' }}>
                  <Grid container direction="row">
                    <Grid style={{ paddingRight: '5px' }}>
                      <Icon style={{ color: '#CC6058' }}>{'cancel'}</Icon>
                    </Grid>
                    <Grid lg={11}>
                      <Typography style={{ color: '#CC6058' }}>
                        {`${t('corporateGoal.label.totalCantBe')} ${(parseFloat(weight) - parseFloat(categoryWeight)).toFixed(1)} %`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              }
              <Grid lg={4} xs={12} item style={{ paddingTop: '5px' }}>
                <Typography fontSize={16} fontWeight={300} color="#AAAAAA">
                  {`${t('corporateGoal.label.form.totalWeight')} 100% `}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {goalCategory &&
            <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600} color={'#404349'}>
                    {t('mygoal.label.goalAlignments')}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginLeft: '20px' }}>
                {((id === 'edit' && originalAlignment !== 2) || id !== 'edit') &&
                  <Grid lg={2} xs={12} item>
                    <Card style={goalAlignment === 0 ? { border: '1px solid #5DA196', cursor: 'pointer', width: '150px', height: '150px' } : { border: null, cursor: 'pointer', width: '150px', height: '150px' }} onClick={() => isOwner ? changeAlignment(0) : {}}>
                      <CardContent style={{ padding: 0 }}>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Radio name="radio" value="1" checked={goalAlignment === 0} size="small" disabled={!isOwner} />
                          </Grid>
                          <Grid item lg={12}>
                            {goalAlignment === 0 ? <NoneAlign style={{ height: 40, width: 40 }} /> : <InNoneAlign style={{ height: 40, width: 40 }} />}
                          </Grid>
                          <Grid item lg={12} mt={goalType !== 2 ? 4.3 : 0}>
                            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#404349">
                              {t('mygoal.label.none')}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                }
                {((id === 'edit' && originalAlignment !== 2) || id !== 'edit') &&
                  <Grid lg={2} xs={12} item>
                    <Card style={goalAlignment === 1 ? { border: '1px solid #5DA196', cursor: 'pointer', width: '150px', height: '150px' } : { border: null, cursor: 'pointer', width: '150px', height: '150px' }} onClick={() => isOwner ? changeAlignment(1) : {}}>
                      <CardContent style={{ padding: 0 }}>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Radio name="radio" value="1" checked={goalAlignment === 1} size="small" disabled={!isOwner} />
                          </Grid>
                          <Grid item lg={12}>
                            {goalAlignment === 1 ? <LinkActive style={{ width: 112, height: 42 }} /> : <LinkInactive style={{ width: 112, height: 42 }} />}
                          </Grid>
                          <Grid item lg={12} mt={goalType !== 2 ? 4.3 : 0}>
                            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#404349">
                              {t('mygoal.label.linking')}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                }
                {goalAlignment != 0 &&
                  <Grid lg={goalAlignment == 1 ? 12 : 9} xs={12} item>
                    <Typography>
                      {requireField(t('mygoal.label.linkingType'))}
                    </Typography>
                  </Grid>
                }
                {goalAlignment === 1 &&
                  <Grid lg={12} xs={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }} >
                    <FormControl sx={{ m: 1, minWidth: 80, mt: 0, ml: 0 }} fullWidth>
                      <Select
                        displayEmpty
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        value={type}
                        onChange={(val) => { handleChange(val.target.value, 'type') }}
                        input={<OutlinedInput size="small" />}
                        error={verifyField.alignment && !type}
                        disabled={!isOwner}
                        classes={!isOwner ? { select: classes.disabled } : {}}
                        renderValue={(selected) => {
                          if (selected?.length == 0) {
                            return <Typography style={{ color: '#AAAAAA', "-webkit-text-fill-color": "initial", fontStyle: 'normal' }}>{t('mygoal.placeholder.linkingType')}</Typography>;
                          } else {
                            return selected
                          }
                        }}
                      >
                        {selectOption?.type?.map((option, idx) => {
                          return <MenuItem key={idx} value={option}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option}</Typography></MenuItem>
                        })}
                      </Select>
                    </FormControl>
                    {(verifyField.alignment && !type) &&
                      warningMessage(verifyField.alignment)
                    }
                  </Grid>
                }
                {goalAlignment === 1 &&
                  <Grid lg={12} xs={12} item>
                    <Typography>
                      {requireField(t('mygoal.label.linking'))}
                    </Typography>
                  </Grid>
                }
                {goalAlignment === 1 &&
                  <Grid lg={12} xs={12} item style={{ paddingTop: '10px' }}>
                    <FormControl sx={{ m: 1, minWidth: 80, ml: 0, mt: 0 }} fullWidth>
                      <Select
                        displayEmpty
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        value={value}
                        onChange={(val) => { handleChange(val.target.value, 'value') }}
                        input={<OutlinedInput size="small" />}
                        error={verifyField.alignment && !value}
                        disabled={!isOwner}
                        classes={!isOwner ? { select: classes.disabled } : {}}
                        renderValue={(selected) => {
                          if (selected == null) {
                            return <Typography style={{ color: '#AAAAAA', "-webkit-text-fill-color": "initial", fontStyle: 'normal' }}>{t('mygoal.placeholder.linking')}</Typography>;
                          } else {
                            return selectOption?.value?.find((item) => item.serial === selected)?.name
                          }
                        }}
                      >
                        {(goalAlignment === 1 && permission !== null) &&
                          selectOption?.value?.map((option, idx) => {
                            if (option.options.permission === 'public' || option.options.permission === permission?.toLowerCase()) {
                              return <MenuItem key={idx} value={option.serial}>
                                <ul style={{ listStyleType: 'none' }}>
                                  <li style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.name}</li>
                                  <li style={{ fontWeight: 400, fontSize: '14px', color: '#AAAAAA' }}>{`(${t('mygoal.placeholder.goalOwner')}: ${option.employee.first_name}  ${option.employee.last_name})`}</li>
                                </ul>
                              </MenuItem>
                            }
                          })
                        }
                      </Select>
                    </FormControl>
                    {(verifyField.alignment && !value) &&
                      warningMessage(verifyField.alignment)
                    }
                  </Grid>
                }
              </Grid>
            </Box>
          }
          <Grid container direction="row">
            <Grid container lg={1} xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => { openApproveDialog(true) }}>
              <Grid item mt={0.5}>
                <BackIcon />
              </Grid>
              <Grid item ml={1}>
                <Typography>
                  {t('label.back')}
                </Typography>
              </Grid>
            </Grid>
            <Grid lg={10} xs={12} item textAlign="center">
              <Button
                size="small"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => { checkField() }}
                color="primary"
                variant="contained"
                style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none' }}
              >
                <Typography>{id === 'edit' ? t('label.save') : t('corporateGoal.label.createGoal')}</Typography>
              </Button>
            </Grid>
          </Grid>
          <WarningDialog open={isApproveDialogOpen} doConfirm={handleConfirmApprove} setValue={handleConfirmApproveDialog} title={t("corporateGoal.label.dialog.discardTitle")} text={t("corporateGoal.label.dialog.discardText")} />
          <WarningDialog open={isConfirmEditOpen} doConfirm={() => confirmPage()} setValue={openConfirmEditOpen} title={t('mygoal.popup.confirmChange')} text={t('mygoal.popup.confirmChangeDesc')} />
          <SimpleDialog open={isSuccessEditOpen} setValue={handleSuccessEdit} text={id === 'edit' ? t("corporateGoal.label.dialog.editSuccess") : t("corporateGoal.label.dialog.saveSuccess")} title={t("label.success")} />
        </Container>
      </Box>
    </>
  );
};
export default CreateFormCorporateGoal;
